"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingBlank = exports.BillingRequestDTOSchema = exports.BillingDTO = exports.BillingDTOSchema = exports.BillingSchema = exports.BillingBaseSchema = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
exports.BillingBaseSchema = zod_1.z.object({
    CompanyName: zod_1.z.string(),
    Address: zod_1.z.string(),
    Town: zod_1.z.string(),
    State: zod_1.z.string(),
    Postcode: zod_1.z.string(),
    Country: zod_1.z.string(),
    AutomaticRenewal: zod_1.z.boolean().default(true),
    UserId: zod_1.z.instanceof(ObjectId_1.ObjectId),
});
exports.BillingSchema = exports.BillingBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.BillingDTOSchema = exports.BillingSchema.extend(__assign({ UserId: (0, ObjectId_1.ObjectIdString)('Invalid UserId') }, CommonMongoModelFields_1.CommonModelDTOFields));
exports.BillingDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            CompanyName: model.CompanyName,
            Address: model.Address,
            Town: model.Town,
            State: model.State,
            Postcode: model.Postcode,
            Country: model.Country,
            AutomaticRenewal: model.AutomaticRenewal,
            UserId: model.UserId._id ? model.UserId._id.toString() : model.UserId.toString(),
            User: (0, ObjectId_1.isPopulated)(model.UserId) ? User_1.UserDTO.convertFromModel(model.UserId) : undefined,
        };
        return dto;
    },
};
exports.BillingRequestDTOSchema = exports.BillingDTOSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields);
exports.BillingBlank = {
    Address: '',
    AutomaticRenewal: true,
    CompanyName: '',
    Country: '',
    Postcode: '',
    State: '',
    Town: '',
    UserId: '',
};
//# sourceMappingURL=Billing.js.map